exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ai-loader[data-v-bbfdb002] {\n  width: 100%;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #f0f0f0;\n}\n.progress-bar[data-v-bbfdb002] {\n  width: 0;\n  border-radius: 2px;\n  animation: animateBackground 5s linear infinite;\n}\n", ""]);

// exports
